import VGPopUp from "components/Controls/VGPopUp";
import {  ReactNode, useEffect, useRef, useState } from "react";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";

import { AddBlogTagOrCategory, BlogPostInfo, DeleteBlogTagOrCategory, EditPostSettings, GetAllBlogPosts, GetBlogAuthors, GetBlogTagsOrCategories, GetPostInfoArrayFromResponse } from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import "../../../components/Style/Blogging.scss"
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";
import { AlertConfirm, DestructiveConfirmation } from "../ConfirmationPopups";
import Loader from "components/Common/Loader";

import CustomMultiSelect from "vagaro-website-rendering/src/components/CustomMultiSelect";
import WebDesigner from "../WebDesigner";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import SelectDropdown from "../SelectDropdown";


export type BlogChipData = {
    id:string,
    name:string
}

export const GetNameListFromChips = (selectedIds:string[],allChips:BlogChipData[])=>{
    if(!selectedIds||selectedIds.length==0) return [];

    let list:string[] = [];
    selectedIds.forEach(id=>{
        let chip = allChips.find(t=>t.id==id);
        if(chip) list.push(chip.name);
    });


    return list;

}

export const GetIdListFromChips = (inNames:string[],allChips:BlogChipData[])=>{

    if(!inNames||inNames.length==0) return [];

    let list:string[] = [];
    inNames.forEach(name=>{
        let chip = allChips.find(t=>t.name==name);
        if(chip) list.push(chip.id);
    });

    return list;

}

export type BlogAuthorData = {

    encUserID:string,
    firstName:string,
    lastName:string,

}

export function BlogSettingsPopup({context,info,onClose,allPosts,onDeleteChip}:{onDeleteChip:()=>void, allPosts:BlogPostInfo[],context:UserContext,info:BlogPostInfo,onUpdate?:(post:BlogPostInfo)=>void,onClose:()=>void}) {

    const convertTitleToSlug = (title:string)=>{
        return title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
    }



    const [cats,setCats] = useState<BlogChipData[]>([]);
    const [tags,setTags] = useState<BlogChipData[]>([]);
    const [authors,setAuthors] = useState<{value:string,label:string}[]>([]);

    const [selectedCats,setSelectedCats] = useState<string[]>([]);
    const [selectedTags,setSelectedTags] = useState<string[]>([]);
    const [authorValue,setAuthor] = useState<string>(info.encAuthor??"");
    const [slugVal,setSlugVal] = useState<string>(info.slug??convertTitleToSlug(info.title));
    const [titleVal,setTitleVal] = useState<string>(info.title);
    const [titleTagVal,setTitleTagVal] = useState<string>(info.titleTag??"");   
    const [metaVal,setMetaVal] = useState<string>(info.metaDescription??"");

    const [slugValidation,setSlugValidation] = useState<string>("");
    const slugInputRef = useRef<HTMLInputElement>(null);

    const [loadCount,setLoadCount] = useState(-1);

    const [isLoading,setIsLoading] = useState(false);

    const UpdateSlugVal =(newSlug:string) =>{


        newSlug = newSlug.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase().trim();

        if(slugInputRef.current) slugInputRef.current.value = newSlug;

        return newSlug;
    }

    const UpdateTitle = (newTitle:string)=> {
        let prevSlug = convertTitleToSlug(titleVal);
        setTitleVal(newTitle);
        if(prevSlug == slugVal || slugVal == "") {
            let newSlug = convertTitleToSlug(newTitle);
            setSlugVal(newSlug);
            if(slugInputRef.current) slugInputRef.current.value = newSlug;
        
        }


    }

    function InitTags(updateSelected:boolean = true){
        GetBlogTagsOrCategories(true,context,(data)=>{
            if(updateSelected)
                setSelectedTags(GetIdListFromChips(info.tags,data));
            if(data.sort)
            setTags(data.sort((a:any,b:any)=>a.name.localeCompare(b.name)));
            setLoadCount((prev)=>prev+1);
        },(error)=>{
            AlertConfirm("There was an issue getting your tags. Please try again later.");
        });

    }

    function InitAuthors(){
        GetBlogAuthors(context,(data)=>{
            if(data?.data?.data){
                let d = data.data.data as BlogAuthorData[];
                let mapped = d.map(t=>({value:t.encUserID,label:`${t.firstName} ${t.lastName}`}));
                mapped.sort((a,b)=>a.label.localeCompare(b.label));
                setAuthors(mapped);
      

                setLoadCount((prev)=>prev+1);
            }
            else{
                AlertConfirm("There was an issue getting your authors. Please try again later.");
            }
        },(error)=>{
            AlertConfirm("There was an issue getting your authors. Please try again later.");
        });
    }

    function InitCategories(updateSelected:boolean = true){
        GetBlogTagsOrCategories(false,context,(data)=>{
          
            if(updateSelected)
            setSelectedCats(GetIdListFromChips(info.category,data));
            if(data.sort)
            setCats(data.sort((a:any,b:any)=>a.name.localeCompare(b.name)));
            setLoadCount((prev)=>prev+1);
        },(error)=>{
            window.alert(error);
            AlertConfirm("There was an issue getting your categories. Please try again later.");
        });


    }


    useEffect(()=>{
        if(slugVal.length<1){
            setSlugValidation("URL Slug cannot be empty.");
        }
        else if(allPosts.find(t=>t.slug==slugVal&&t.id!=info.id)){
            setSlugValidation("URL Slug already exists.");
        }
        else if(slugValidation!=""){
            setSlugValidation("");
        }


    },[slugVal]);

    useEffect(()=>{
        InitTags();
        InitCategories();
        InitAuthors();

  //eslint-disable-next-line
    },[]);



   return <div >
    {isLoading && <Loader/>}
        <div className = "form-content">
        <FormRow label="Post Name">
            <input onInput={(e)=>{
                UpdateTitle(e.currentTarget.value);
            }} defaultValue={info.title} type="text"  maxLength={160} className="form-control"  placeholder="Post Name" />
        </FormRow>
        <FormRow label="Post Author:">
            <SelectDropdown allowFilter={true} key={loadCount} options={ (loadCount<2)?[{label:"Loading...",value:info.author??""}]: [{label:"Anonymous",value:""},...authors]} defaultValue={authorValue} onChange={(v:string)=>setAuthor(v)} />
            {/* <input  onInput={(e)=>{setAuthor(e.currentTarget.value)}} defaultValue={info.author} type="text" className="form-control" placeholder="Author Name" /> */}
        </FormRow>
        <FormRow label="URL Slug:">
            <input  onInput={(e)=>{setSlugVal(UpdateSlugVal(e.currentTarget.value))}}
            ref={slugInputRef} defaultValue={slugVal} type="text" className="form-control" placeholder="post-name" />
            {slugValidation.length>0&&<div className="validation-label">{slugValidation}</div>}
        </FormRow>
        <FormRow label="Meta Description:">
            <textarea 
            defaultValue={info.metaDescription}
            onInput={(e)=>{
                setMetaVal(e.currentTarget.value);
            }} maxLength={500} className="form-control" placeholder="This post is about finding salons, spas and others." />
        </FormRow>
        <FormRow label="Title Tag:">
            <input 
            defaultValue={info.titleTag}
            onInput={(e)=>setTitleTagVal(e.currentTarget.value)}  type="text" maxLength={100} className="form-control" placeholder="Post Name" />
        </FormRow>
        <FormRow label="Post Tags:">
            <CustomMultiSelect  
            key = {tags.length}
            useDualHeader={true}
 
            openUpwards = {true}
            defaultValues={ selectedTags}
                   options={tags.map(t => ({ label: t.name, value: t.id })).sort((a,b)=>a.label.localeCompare(b.label))}
                   placeholder={loadCount<2?"Loading...":"Select Tags"}
                   onChange={(value) => { setSelectedTags(value) } } startOpen={false} footer={<div style={{position:"sticky",bottom:0,background:"white"}}>       <button style={{padding:"8px 12px"}}
                  
                   className="invisible-button w-full align-center flex-row gap-med text-align-left gray-hover close-pop-up"
                   onClick={(e) => {
                       OpenBlogCategoryAndTagsPopup(context, true,onDeleteChip, ()=>InitTags(false))
           
                   }}
                   ><b className="font-large">+</b>&nbsp;&nbsp; Edit Tags</button></div>}              
             />
        </FormRow>
        <FormRow label="Post Categories:">
        <CustomMultiSelect  
             key = {cats.length}
            useDualHeader={true}
          
                    defaultValues={selectedCats}
                    openUpwards = {true}
                   options={cats.map(t => ({ label: t.name, value: t.id })).sort((a,b)=>a.label.localeCompare(b.label))}
                   placeholder={loadCount<2?"Loading...":"Select Categories"}
                   onChange={(value) => {setSelectedCats(value) } } startOpen={false} footer={<div style={{position:"sticky",bottom:0,background:"white"}}>      <button style={{padding:"8px 12px"}}
                   className="invisible-button w-full align-center flex-row gap-med text-align-left gray-hover close-pop-up"
                    onClick={(e) => {
                        OpenBlogCategoryAndTagsPopup(context, false,onDeleteChip,()=>InitCategories(false))
            
                    }}
                    ><b className="font-large">+</b>&nbsp;&nbsp; Edit Categories</button></div>}            
             />
        </FormRow>
 


        </div>

        <div className="flex-row justify-end gap-large" style={{paddingTop:"20px"}}>
                <button className="w-button w-button-secondary" onClick={onClose}>Cancel</button>
                <button className="w-button w-button-primary" style={{opacity:(slugValidation!=""?".5":"1"),pointerEvents:(slugValidation!=""?"none":"all")}}  onClick={(e) => {

                    if(slugValidation!=""){

                        return;
                    }

                    info.category = selectedCats;
                    info.tags = selectedTags;
                    info.title = titleVal;
                    info.slug = slugVal;


                    info.author =  authorValue;//authors.find(t=>t.value==authorValue)?.label??authorValue;
                    info.encAuthor = authorValue;
                    info.metaDescription = metaVal;
                    info.titleTag = titleTagVal;
                    

                    let newInfo = {...info};
                    setIsLoading(true);

            
                    EditPostSettings(context,info.id,newInfo,(data)=>{

                        //reformat from IDs to name when displaying in table
                        info.category = GetNameListFromChips(selectedCats,cats);
                        info.tags = GetNameListFromChips(selectedTags,tags);
                        info.author = authors.find(t=>t.value==authorValue)?.label??authorValue;

                
                        setIsLoading(false);
                        onClose();
                    },(error)=>{
                        AlertConfirm("There was an issue saving your post settings. Please try again later.");
                        setIsLoading(false);
                    });


                 }}>
                    {info.status == 2?"Save & Publish":"Save"}
        
   
                    </button>
            </div>
</div>


}



function FormRow({label,subText, children}:{label:ReactNode,subText?:string,children?:any}) {

    return (
        <div className="form-row">
            <label className="form-label">{label}</label>
            {subText && <div className="form-text">{subText}</div>}
            {children}
        </div>
    )

}

export function OpenBlogSettingsFromEditor(designer:WebDesigner){

    let title = document.getElementById("blog-heading-input");

    if(title){
      let val = (title as any).value.trim();
      designer.state.postInfo.title = val;
      
    }

    OpenBlogSettingsPopupAndCallAPI(designer.props.siteData.userContext,designer.state.postInfo,()=>designer!.toggleLoading(false),(info:BlogPostInfo)=>{
        setTimeout(()=>{

            let root = designer.state.layout;
            let blogHeading = root.children.find((x)=>x.typename == wBComponentTypeNames.blogHeading);

            if(designer.state.postInfo.id == info.id){
                designer.setState({postInfo:info});
                let txt = document.getElementById("blog-heading-input");
                if(txt){
                 
                    (txt as any).value = info.title;
                    (txt as any).click();
                 
                   
                }
            }

            if(blogHeading){
                setNodeComponentAttributeValue(blogHeading,"blog-title",designer.state.postInfo.title);
                setNodeComponentAttributeValue(blogHeading,"blog-hero-image",designer.state.postInfo.image);
                setNodeComponentAttributeValue(blogHeading,"blog-date",designer.state.postInfo.date);
                setNodeComponentAttributeValue(blogHeading,"blog-author",designer.state.postInfo.author);
             
                designer.flagDirtySave();
                blogHeading.forceUpdate&&blogHeading.forceUpdate();
            }

        },100);
    });

}


export function OpenBlogSettingsPopupAndCallAPI(context:UserContext,info:BlogPostInfo,onFinishLoading:()=>void,onSave?:(info:BlogPostInfo)=>void) {


    GetAllBlogPosts(context,(data)=>{
        let result  =GetPostInfoArrayFromResponse(data);

        onFinishLoading();
        OpenBlogSettingsPopup(context,info,result,()=>{},onSave);

    },(error)=>{ 
        AlertConfirm("There was an issue getting your posts. Please try again later.");
        onFinishLoading();

    });

}

export function OpenBlogSettingsPopup(context:UserContext,info:BlogPostInfo,allPosts:BlogPostInfo[],onDelete:()=>void,onSave?:(blogInfo:BlogPostInfo)=>void) {


        let dom = document.getElementById("OpenDialog1");
        const PopupClose = () => {
            let dom = document.getElementById("OpenDialog1");
            if (dom) unmountComponentAtNode(dom);
         
            onSave&&onSave(info);
           
        };

    

    
        if(dom)
        ReactDOM.render(
            <>
            <VGPopUp
              id={"blog-post-settings-popup"}
              show={true}
              onHide={PopupClose}
              title={"Post Settings"}
              dialogClassName="block-edit"
              body={
                <div className="alertContent">
                   <BlogSettingsPopup onDeleteChip={onDelete} allPosts={allPosts} context={context} info={info} onUpdate={()=>{}} onClose={PopupClose}/>
                </div>
              }

              isRemoveTabModalIndex={false}
              isShowFooter={false}
              size={"lg"}
              backdrop={true}
            />
      
            </>,
            dom);
        
 
    
    }
    
export function OpenBlogCategoryAndTagsPopup(context:UserContext,isTag:boolean,onDelete:()=>void,onClose?:()=>void,existingChips?:BlogChipData[]) {

    let typeStr = isTag?"Tag":"Category";
    

    let dom = document.getElementById("OpenDialog2");
    const PopupClose = () => {
        let dom = document.getElementById("OpenDialog2");
        if (dom) unmountComponentAtNode(dom);
      
       onClose&&onClose();
    };

   
let plural = (isTag == false ? "Categories":"Tags");


    if(dom)
    ReactDOM.render(
       
        <VGPopUp
            key = {typeStr}
          id={"cat-tag-settings-popup"}
          show={true}
          onHide={PopupClose}
          title={`Edit ${plural}`}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
               <BlogCategoryAndTags onDelete={onDelete} context={context} isTag={isTag}  existingChips={existingChips} onClose={PopupClose}/>
            </div>
          }

          isRemoveTabModalIndex={false}
          isShowFooter={false}
          size={"md"}
          backdrop={true}
        />
  
       ,
        dom);
    

}

const SortChips = (a:BlogChipData,b:BlogChipData)=>{
    return a.name.localeCompare(b.name);
}

export function BlogCategoryAndTags({isTag,existingChips,onClose,context,onDelete}:{onDelete:()=>void,context:UserContext,isTag:boolean,existingChips?:BlogChipData[],onClose:()=>void}) {

    const [allChips,setAllChips] = useState(existingChips?existingChips.sort(SortChips):[]);
    const [isLoading,setIsLoading] = useState(false);

    let typeStr = isTag?"Tag":"Category";
    let typeStrLower = typeStr.toLowerCase();

    const DeleteChip = (id:string)=>{
        DestructiveConfirmation(`Are you sure you want to delete this ${typeStrLower}?`,()=>{


            DeleteBlogTagOrCategory(isTag,context,id,(data)=>{

                setIsLoading(false);
                setAllChips(allChips.filter(t=>t.id!=id));
                onDelete();

            },(error)=>{
                AlertConfirm(`There was an issue deleting this ${typeStrLower}. Please try again later.`);
                setIsLoading(false);
            });
            //setAllChips(allChips.filter(t=>t.id!=id))
         });
    }


    const AddChip = (name:string)=>{

        if(allChips.find(t=>t.name.toLowerCase()==name.toLowerCase())){ 

            AlertConfirm(`The ${typeStrLower} '${name}' already exists.`);
            return;
        }

        setIsLoading(true);
        AddBlogTagOrCategory(isTag,context,name,(data)=>{
            setIsLoading(false);
            onClose();

        },(error)=>{
            AlertConfirm(`There was an issue creating this ${typeStrLower}. Please try again later.`);
            setIsLoading(false)
        });

    }

    const GetAllChips = ()=>{
        setIsLoading(true);
        GetBlogTagsOrCategories(isTag,context,(data)=>{
            setAllChips(data.sort(SortChips));

        },(error)=>{
            AlertConfirm(`There was an issue getting your ${typeStrLower}s. Please try again later.`);
        });
        setIsLoading(false);

    }

    useEffect(()=>{

        //if(!existingChips){ // if existing chips weren't pass get them from the server
            GetAllChips();
        
//eslint-disable-next-line
    },[]);

    const inputRef = useRef<HTMLInputElement>(null);


    let plural = (isTag == false ? "categories":"tags");

    return < >
    {isLoading && <Loader/>}
            <div className = "form-content">
                <div className="form-light-text " style={{marginBottom:"16px"}}>{`Add a new ${typeStrLower} by creating a ${typeStrLower} name.`}</div>
            
            <FormRow label={`New ${typeStr} Name:`}>
                <input  ref={inputRef} onInput={(e)=>{
                    let test = e.currentTarget.value;
                    test = test.replaceAll("/",'');
                    test = test.replaceAll("\\",'');
                    e.currentTarget.value = test;
                }} type="text"  maxLength={50} className="form-control"  placeholder="Enter Name" />
            </FormRow>
            <FormRow label={`Current ${plural}:`}>
                <div className="form-light-text" style={{margin:"6px 0 10px"}}>{`Remove a ${typeStr} by deleting it`}</div> 
                <div className="flex-row flex-wrap scrollable w-full gap-med" style={{maxHeight:"280px"}}>
                    {allChips.map(tag=><CatChip name={tag.name}
                        onDelete={()=>{ DeleteChip(tag.id);}}
                    
                    />)}

                </div>
            </FormRow>
            
            </div>
            <div className="flex-row justify-end gap-large" style={{paddingTop:"20px"}}>
                <button className="w-button w-button-secondary" onClick={onClose}>Cancel</button>
                <button className="w-button w-button-primary" onClick={(e) => { 
                    if(inputRef.current?.value) AddChip(inputRef.current.value.trim());
                        else{
                            AlertConfirm(`Please enter a ${typeStrLower} name before saving.`)
                        }
                }}>Save</button>
            </div>
        </>



}



function CatChip({name,onDelete}:{name:string,onDelete?:()=>void}) {

    return <div className="b-chip center-all">{name} <button onClick={onDelete} className="invisible-button p-0"><XIcon/></button></div>
}

